import React from "react";
import { PartialSanityImageType } from "../SanityImage/types";
import {
  calculateCroppedDimensions,
  isSanityImagePresent
} from "../SanityImage/utils";
import { ImageAspectRatio, ImageRatio, ImageRatioProps } from "./ImageRatio";

export interface SanityImageRatio extends Omit<ImageRatioProps, "ratio"> {
  image?: PartialSanityImageType;
  ratio: ImageAspectRatio | "auto";
}

export const SanityImageRatio: React.FC<
  React.PropsWithChildren<SanityImageRatio>
> = ({ children, image, ratio, ...props }) => {
  if (ratio == "auto") {
    if (!image?.asset?._id || !isSanityImagePresent(image)) return null;
    const dimensions = calculateCroppedDimensions(image);
    return (
      <ImageRatio ratio="auto" {...props} {...dimensions}>
        {children}
      </ImageRatio>
    );
  } else
    return (
      <ImageRatio ratio={ratio} {...props}>
        {children}
      </ImageRatio>
    );
};
